import { friendlyShortImpactTitle, friendlyValence } from '@upright/common/utils';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { FigureBoxesWithExplanation } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/common/figures-boxes-with-explanation';
import { useImpactDetailsRevenue } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/common/use-impact-details-revenue';
import { useRealWorldComparison } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/real-world-units-comparisons';
import { useGenericProductComparisons } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/real-world-units-comparisons/generic-products';
import styled from 'styled-components';

export function useComparisonBoxes() {
  const genericComparisons = useGenericProductComparisons();
  const realWorldComparsions = useRealWorldComparison();
  return [...realWorldComparsions, ...genericComparisons];
}

export function ImpactSpecificFigureBoxes() {
  const comparisonBoxes = useComparisonBoxes();
  const context = useNetImpactLensContext();
  const title = useTitlePart();
  const [valence, impact] = [context?.state.valence, context?.state.impact];
  if (!valence || !impact) {
    return <></>; // should not happen
  }
  return <FigureBoxesWithExplanation boxes={comparisonBoxes} overlayTitle={title !== undefined && title} />;
}

function useTitlePart() {
  const { isFallback: isFallBackRevenue } = useImpactDetailsRevenue();
  const genericComparisons = useGenericProductComparisons();
  const context = useNetImpactLensContext();
  const [valence, impact] = [context?.state.valence, context?.state.impact];

  if (!valence || !impact) {
    return undefined; // should not happen
  }

  if (genericComparisons.length !== 0 && isFallBackRevenue) {
    return (
      <>
        Per <b>$1M of revenue</b>, size of impact corresponds to the{' '}
        <TitleDynamicElement>{friendlyValence(valence).toLowerCase()}</TitleDynamicElement>{' '}
        <TitleDynamicElement>{friendlyShortImpactTitle(impact).toLowerCase()} impact</TitleDynamicElement> of:
      </>
    );
  } else if (genericComparisons.length !== 0 && !isFallBackRevenue) {
    return (
      <>
        Size of impact corresponds to the{' '}
        <TitleDynamicElement>{friendlyValence(valence).toLowerCase()}</TitleDynamicElement>{' '}
        <TitleDynamicElement>{friendlyShortImpactTitle(impact).toLowerCase()} impact</TitleDynamicElement> of:
      </>
    );
  } else if (isFallBackRevenue) {
    return (
      <>
        Per <b>$1M of revenue</b>, size of impact is equal to:
      </>
    );
  } else {
    return undefined;
  }
}

const TitleDynamicElement = styled.span`
  font-weight: bold;
`;
